export type TitleNewsStory = {
  date: string;
  title: string;
  summary: string;
  details: string[];
};

export function parseTitleNews(markdown: string): TitleNewsStory[] {
  const stories: TitleNewsStory[] = [];
  let date = "Latest dispatch";
  let current: TitleNewsStory | undefined;
  let paragraphs: string[] = [];

  const flushParagraph = () => {
    if (!current || paragraphs.length === 0) return;
    const paragraph = paragraphs.join(" ").trim();
    if (paragraph) current.summary = current.summary ? `${current.summary} ${paragraph}` : paragraph;
    paragraphs = [];
  };
  const flushStory = () => {
    flushParagraph();
    if (current?.title) stories.push(current);
    current = undefined;
  };

  for (const rawLine of markdown.replace(/\r/g, "").split("\n")) {
    const line = rawLine.trim();
    if (!line || line === "---") { flushParagraph(); continue; }
    if (line.startsWith("# ")) continue;
    if (line.startsWith("## ")) {
      flushStory();
      date = line.slice(3).trim() || "Latest dispatch";
      continue;
    }
    if (line.startsWith("### ")) {
      flushStory();
      current = { date, title: line.slice(4).trim(), summary: "", details: [] };
      continue;
    }
    if (!current) continue;
    if (line.startsWith("- ")) {
      flushParagraph();
      current.details.push(line.slice(2).trim());
      continue;
    }
    paragraphs.push(line.replace(/^\*\*(.+)\*\*$/, "$1"));
  }
  flushStory();
  return stories;
}
